module.exports = __webpack_public_path__ + "static/media/LookDown.svg";